import {
    changeEvent, clickEvent, customDocumentEvent, customEvent,
    dispatchCustomEvent, documentLoadEvent, fireChangeEvent, fireInputEvent, inputEvent,
} from "../../../../../webpack/modules/events";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {calculateCustomSizePrice, calculatePrice} from "../../../../../webpack/modules-optimized/product";
import {
    hideElement,
    showElement,
    slideDown,
    slideUp
} from "../../../../../webpack/modules-optimized/element-visibility";
import {getNewTomSelectQuantity, initTomSelectQuantity} from "../../../../../webpack/modules-optimized/tomselect";
import {hideOptionErrors, updatePriceElements} from "../../../../../webpack/modules-optimized/product-page";
import {formatPrice} from "../../../../../webpack/modules-optimized/price";
import {showCollapse, hideCollapse} from "../../../../../webpack/modules-optimized/collapse";

documentLoadEvent(function() {
    selectUniqueCustomSizeOption();
    initTooltips();
    if (document.querySelectorAll('#product-page .options[data-type="size"][data-option-type="selectable"].force-open-info').length) openInstructions();
});

changeEvent('#product-page .options[data-option-type="selectable"] input[name="size"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let previewText = element.dataset.previewText;
    let sizes = offcanvas.querySelectorAll('.size');
    let size = element.closest('.size') || element.nextElementSibling;
    let customSizeCollapse = Collapse.getInstance(offcanvas.querySelector('.custom-size .body'));
    let isCustomSize = element.value === 'custom-size';

    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': offcanvas,
            'container': container,
            'previewElement': previewElement,
            'previewText': previewText
        }
    );

    sizes.forEach((size) => size.classList.remove('selected'));
    size.classList.add('selected');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (!isCustomSize && customSizeCollapse) customSizeCollapse.hide();
    if (!isCustomSize) {
        hideOffcanvas(offcanvas.id);
        resetCustomSizeForm();
        hideElement(offcanvas.querySelector('.error-custom-sizes'));
        hideElement(offcanvas.querySelector('.error-min-size'));
        hideElement(offcanvas.querySelector('.error-max-size'));
    }
    updatePriceElements(container);
    hideOptionErrors(offcanvas);
});

customEvent('show.bs.collapse', '#product-page .options[data-option-type="selectable"] .custom-size .body', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let sizes = offcanvas.querySelectorAll('.size');
    let size = element.closest('.size');
    let input = container.querySelector('input[name="size"][value="custom-size"]');

    input.checked = true;
    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': offcanvas,
            'container': container,
            'previewElement': previewElement
        }
    );
    sizes.forEach((size) => size.classList.remove('selected'));
    size.classList.add('selected');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
});


//SINGLE CUSTOM SIZE

let timeoutCustomSizeInputs = null;
inputEvent('#product-page .options[data-option-type="selectable"] input[name="custom-width"]', false, function(element) {
    let container = document.getElementById('product-page')
    let productId = container.dataset.productId;
    let offcanvas = element.closest('.offcanvas');
    let customSize = element.closest('.custom-size');
    let inputWidth = element;
    let inputHeight = customSize.querySelector('.custom-size-height');
    let errorElement = offcanvas.querySelector('.error-custom-sizes');
    let size = container.querySelector('input[name="size"][value="custom-size"]');

    size.dataset.width = '';
    size.dataset.height = '';

    clearTimeout(timeoutCustomSizeInputs);
    timeoutCustomSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'calculateCustomHeight',
                {
                    'productId': productId,
                    'container': container,
                    'option': offcanvas,
                    'inputWidth': inputWidth,
                    'inputHeight': inputHeight,
                    'errorElement': errorElement,
                    'inputBlur': true
                }
            );
        },
        200
    );
});


//CUSTOM BOTH SIZE

let timeoutBothSizeInputs = null;
inputEvent('#product-page .options[data-option-type="selectable"] input[name="bothWidth"], #product-page .options[data-option-type="selectable"] input[name="bothHeight"]', false, function(element) {
    let offcanvas = element.closest('.offcanvas');
    let customSize = element.closest('.custom-size');
    let widthInput = customSize.querySelector('input[name="bothWidth"]');
    let heightInput = customSize.querySelector('input[name="bothHeight"]');
    let size = customSize.querySelector('input[name="size"][value="custom-size"]');
    let minSizeError = offcanvas.querySelector('.error-min-size');
    let maxSizeError = offcanvas.querySelector('.error-max-size');
    let errorWidth = offcanvas.querySelector('.error-width');
    let errorHeight = offcanvas.querySelector('.error-height');

    size.dataset.width = '';
    size.dataset.height = '';

    clearTimeout(timeoutBothSizeInputs);
    timeoutBothSizeInputs = setTimeout(
        function() {
            dispatchCustomEvent(
                'validateBothSize',
                {
                    'option': offcanvas,
                    'widthInput': widthInput,
                    'heightInput': heightInput,
                    'minSizeError': minSizeError,
                    'maxSizeError': maxSizeError,
                    'errorWidth': errorWidth,
                    'errorHeight': errorHeight
                }
            );
        },
        300
    );
});


customDocumentEvent('customHeightCalculated successValidateBothSize', async function() {
    if (!document.querySelector('.options[data-option-type="selectable"][data-type="size"]') || document.querySelector('#modal-product')) return;
    let container = document.getElementById('product-page');
    let option = container.querySelector('.options[data-option-type="selectable"][data-type="size"]');
    let customSize = container.querySelector('.custom-size');
    let width = parseFloat(container.querySelector('input[name="custom-width"], input[name="bothWidth"]').value);
    let height = parseFloat(container.querySelector('.custom-size-height').innerHTML || container.querySelector('input[name="bothHeight"]').value);
    let validateButton = customSize.querySelector('button.validate');
    let continueConfigurationButton = option.querySelector('button.continue-configuration');
    let size = customSize.querySelector('input[name="size"][value="custom-size"]');
    let pack = container.querySelector('input[name="pack"]:checked');
    let color = container.querySelector('input[name="color"]:checked');
    let supportColor = container.querySelector('input[name="support-color"]:checked');
    let headerPrice = customSize.querySelector('.header .size-price');
    let bodyPrice = customSize.querySelector('.body .custom-price');
    let priceOf = customSize.querySelectorAll('.price-of');
    let quantity = customSize.querySelector('.quantity-selector');

    let responseCalculatePrice = await calculateCustomSizePrice(
        container.dataset.productId,
        width,
        height,
        pack ? pack.value : null,
        color ? color.value : null,
        supportColor ? supportColor.value : null
    );
    let price = responseCalculatePrice.price;

    price = formatPrice(price);
    headerPrice.innerHTML = price;
    bodyPrice.querySelector('.value').innerHTML = price;
    if (!quantity) bodyPrice.classList.remove('d-none');
    size.dataset.width = width;
    size.dataset.height = height;
    if (validateButton) validateButton.classList.remove('disabled');
    if (continueConfigurationButton) slideDown(continueConfigurationButton);
    priceOf.forEach((element) => hideElement(element));
    if (quantity) {
        let productId = container.dataset.productId;
        let view = await getNewTomSelectQuantity(productId, customSize.id, price);
        if (view) {
            let parent = quantity.parentElement;
            quantity.tomselect.destroy();
            parent.innerHTML = view;
            quantity = customSize.querySelector('.quantity-selector');

            let tomSelect = initTomSelectQuantity(quantity);

            tomSelect.on('dropdown_close', function () {
                let wrapper = tomSelect.wrapper;
                let quantity = tomSelect.getValue();
                if (!size) return;
                size.dataset.quantity = quantity;
                size.checked = quantity > 0;
                fireChangeEvent(size, false);
            });
        }

        if (quantity.value === '0') quantity.tomselect.setValue(1);
        quantity.tomselect.updateOption('0', {value: 0, text: 0, disabled: true});
        quantity.tomselect.enable();
    }
    fireChangeEvent(size, false);
});


customDocumentEvent('customHeightErrorCalculate', function() {
    if (!document.querySelector('.options[data-option-type="selectable"][data-type="size"]') || document.querySelector('#modal-product')) return;
    resetCustomSizeForm(false);
});

customDocumentEvent('errorValidateBothSize', function() {
    if (!document.querySelector('.options[data-option-type="selectable"][data-type="size"]') || document.querySelector('#modal-product')) return;
    resetCustomSizeForm(false, false);
});

changeEvent('#product-page .options[data-option-type="selectable"] .custom-size .quantity', true, function(element) {
    let quantity = parseInt(element.value);
    let rawPrice = element.options[element.selectedIndex].dataset.rawPrice;
    let container = element.closest('.custom-size');
    let size = container.querySelector('input[name="size"][value="custom-size"]');

    size.dataset.quantity = quantity;
    size.checked = quantity > 0;
    fireChangeEvent(size, false);
    if (rawPrice) container.querySelector('.custom-price .value').innerHTML = rawPrice;
});

clickEvent('#product-page .options[data-type="size"][data-option-type="selectable"] .custom-size .custom-size-width, #product-page  .options[data-type="size"][data-option-type="selectable"] .custom-size .custom-size-height', true, function(element) {
    let scope = element.closest('.options[data-type="size"]');
    let info = scope.querySelector('.option-info');

    if (!info || !info.classList.contains('show')) return;
    hideCollapse(info.id);
});

customEvent('hidden.bs.collapse', '#product-page .options[data-option-type="selectable"][data-type="size"] .small-info', true, function(element){
    element.classList.remove('small-info');
});

function resetCustomSizeForm(resetWidth = true, resetHeight = true)
{
    let container = document.getElementById('product-page');
    let option = container.querySelector('.options[data-option-type="selectable"][data-type="size"]');
    let customSize = container.querySelector('.custom-size');
    let validateButton = customSize.querySelector('button.validate');
    let continueConfigurationButton = option.querySelector('button.continue-configuration');
    let width = customSize.querySelector('input[name="custom-width"], input[name="bothWidth"]');
    let height = customSize.querySelector('.custom-size-height, input[name="bothHeight"]');
    let headerPrice = customSize.querySelector('.header .size-price');
    let bodyPrice = customSize.querySelector('.body .custom-price');
    let priceOf = customSize.querySelectorAll('.price-of');
    let quantity = customSize.querySelector('.quantity-selector');
    let bodyPriceValue = bodyPrice.querySelector('.value');

    headerPrice.innerHTML = headerPrice.dataset.defaultPrice;
    bodyPrice.querySelector('.value').innerHTML = '';
    if (!bodyPrice.classList.contains('d-none') && !quantity) bodyPrice.classList.add('d-none');
    if (bodyPriceValue.dataset.defaultValue) bodyPriceValue.innerHTML = bodyPriceValue.dataset.defaultValue;
    if (validateButton && !validateButton.classList.contains('disabled')) validateButton.classList.add('disabled');
    if (continueConfigurationButton) slideUp(continueConfigurationButton);
    priceOf.forEach((element) => showElement(element));
    if (resetWidth) width.value = '';
    if (resetHeight) {
        height.innerHTML = '';
        height.value = '';
    }
    if (quantity && quantity.tomselect) {
        quantity.value = 0;
        quantity.tomselect.disable();
        quantity.tomselect.sync();
    }
}

function selectUniqueCustomSizeOption()
{
    let container = document.querySelector('.options[data-option-type="selectable"][data-type="size"]');
    if (!container) return;
    let option = container.querySelector('.custom-size.unique-option');
    if (!option) return;
    let input = option.querySelector('input[name="size"]');
    let quantity = option.querySelector('.quantity-selector');
    let showExpanded = option.classList.contains('show-expanded');

    option.classList.add('selected');
    input.checked = true;
    if (showExpanded) {
        let header = option.querySelector('.header');
        let collapse = Collapse.getOrCreateInstance(option.querySelector('.collapse'));
        collapse.show();
        header.removeAttribute('data-bs-target');
    }
    if (quantity) {
        if (!quantity.classList.contains('quantity-add-to-cart')) quantity.classList.add('quantity-add-to-cart');
        let tomSelect = initTomSelectQuantity(quantity);

        tomSelect.on('dropdown_close', function() {
            let wrapper = tomSelect.wrapper;
            let size = wrapper.closest('.size');
            let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`);
            let quantity = tomSelect.getValue();

            if (!input) return;

            input.checked = quantity > 0;
            input.dataset.quantity = quantity;
            fireChangeEvent(input);
        });
    }
}

function openInstructions()
{
    let offcanvas = document.querySelector('#product-page .options[data-type="size"].offcanvas');
    let info = offcanvas.querySelector('.option-info');

    if (!info) return;

    info.classList.add('small-info');
    showCollapse(info.id);
}

function initTooltips()
{
    document.querySelectorAll('#product-page .has-tooltip').forEach(function(input) {
        new Tooltip(input, {boundary: input, placement: 'bottom', container: input.closest('.row')});
    });
}